import { Route, Routes } from 'react-router-dom';
import React from 'react';
import NightRates from './index';

export default function NightRatesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<NightRates />} />
    </Routes>
  );
}
